<template>
  <div class="ma-3 px-4">
    <v-row class="pr-3">
      <v-col cols="12" md="2">
        <v-text-field
          v-model="form.application_id"
          hide-details="auto"
          label="Application ID"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="form.usn_id"
          hide-details="auto"
          label="USN"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="form.transaction_id"
          hide-details="auto"
          label="Transaction ID"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4"
        ><v-btn class="accent white--text" :loading=loading @click="searchFilter">
          Search
        </v-btn>
        <v-btn @click="download()" ::loading=downloadLoading class="accent white--text ml-2">
          <v-icon>mdi-download</v-icon> Download
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pt-1">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :loading="loading"
            :items="unsettledTransactions"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
          >
            <template #[`item.settled_transactions`]="{ item }">
              <v-icon small class="mr-2" color="accent" @click="navigate(item)">
                mdi-dots-horizontal
              </v-icon>
            </template>
            <template #[`item.transaction_date`]="{ value }">
              {{ formatDate(value, false) }}
            </template>
            <template #[`item.application_id`]="{ item }">
              {{ item.application_id ? item.application_id : "-" }}
            </template>
            <template #[`item.usn_id`]="{ item }">
              {{ item.usn_id ? item.usn_id : "-" }}
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { unsettledTransactionHeaders } from "@/constants/headers";
export default {
  data() {
    return {
      unsettledTransaction: {},
      unsettledTransactions: [],
      headers: unsettledTransactionHeaders,
      form: {},
      loading: false,
      downloadLoading: false,
    };
  },
  watch: {},
  computed: {},
  async created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Unsettled Transactions" }]);
    this.initialise();
  },
  methods: {
    initialise() {
      this.searchFilter();
    },
    async getUnsettledTransactions(queryString) {
      this.loading = true;
      await this.$axios
        .get(`unsettled_transactions?${queryString}`)
        .then((res) => {
          this.unsettledTransactions = res.data.data.sort(
            (a, b) => new Date(b.date) - new Date(a.date),
          );
          this.loading = false;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message || "No Data Found",
            color: "error",
          });
          this.loading = false;
        });
    },
    formatDate(dateString, needHour) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const hour = date.getHours().toString().padStart(2, "0");
      const minute = date.getMinutes().toString().padStart(2, "0");
      return needHour
        ? `${month}-${day}-${year} ${hour}:${minute}`
        : `${day}-${month}-${year}`;
    },
    async download() {
      this.downloadLoading = true;
      const queryString = this.objectToQueryParams({
        ...this.form,
      });
      this.$axios
        .get(`/download_unsettled_transactions?${queryString}`, {
          responseType: "blob",
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: "text/csv" }),
            url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "unsettled_transactions.csv");
          document.body.appendChild(link);
          link.click();
        });
    },
    searchFilter() {
      const queryString = this.objectToQueryParams({
        ...this.form,
      });
      this.getUnsettledTransactions(queryString);
    },
    objectToQueryParams(obj) {
      if (obj.year_batch) {
        const [year, batch] = obj.year_batch.split("-");
        obj.year = parseInt(year, 10);
        obj.batch = parseInt(batch, 10);
        delete obj.year_batch;
      }
      return Object.keys(obj)
        .filter(
          (key) =>
            obj[key] !== undefined && obj[key] !== null && obj[key] !== "",
        )
        .map(
          (key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`,
        )
        .join("&");
    },
  },
};
</script>

<style scoped>
.v-data-table::v-deep th {
  padding-right: 0px !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  padding-right: 0px !important;
}
</style>
